import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-previous-surgery-crohn',
    templateUrl: './bar-chart-stable-unstable-previous-surgery-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-previous-surgery-crohn.component.css']
})

export class BarChartStableUnstablePreviousSurgeryCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  attivitaLieve = [];
  attivitaModerata = [];
  attivitaGrave = [];
  // other arrays
  stabiliLieveNoInterventi = 0;
  stabiliModerataNoInterventi = 0;
  stabiliGraveNoInterventi = 0;
  stabiliRemissioneNoInterventi = 0;
  instabiliMiglLieveNoInterventi = 0;
  instabiliMiglModerataNoInterventi = 0;
  instabiliMiglGraveNoInterventi = 0;
  instabiliPegLieveNoInterventi = 0;
  instabiliPegModerataNoInterventi = 0;
  instabiliPegGraveNoInterventi = 0;
  instabiliMiglRemissioneNoInterventi = 0;
  instabiliPegRemissioneNoInterventi = 0;
  
  stabiliLieveInterventi = 0;
  stabiliModerataInterventi = 0;
  stabiliGraveInterventi = 0;
  stabiliRemissioneInterventi = 0;
  instabiliMiglLieveInterventi = 0;
  instabiliMiglModerataInterventi = 0;
  instabiliMiglGraveInterventi = 0;
  instabiliPegLieveInterventi = 0;
  instabiliPegModerataInterventi = 0;
  instabiliPegGraveInterventi = 0;
  instabiliMiglRemissioneInterventi = 0;
  instabiliPegRemissioneInterventi = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableCrohnPreviousSurgery: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['NO PRECEDENTI CHIRURGICI-STABILI','NO PRECEDENTI CHIRURGICI-IN MIGLIORAMENTO','NO PRECEDENTI CHIRURGICI-IN PEGGIORAMENTO',
  'PRECEDENTI CHIRURGICI-STABILI','PRECEDENTI CHIRURGICI-IN MIGLIORAMENTO','PRECEDENTI CHIRURGICI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 20,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 20,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 20,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 20,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveGenderStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveGenderStableAndUnstable(){
    this.subscription = this.doctorService.getCrohnStableAndUnstablePreviousSurgery().subscribe( data => {
      let keys = Object.keys(data);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        if (key === 'StabiliRemissioneNoInterventi'){
          this.stabiliRemissioneNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglLieveInterventi'){
          this.instabiliMiglLieveInterventi = values[i];
        }
        else if (key === 'InstabiliMiglModerataInterventi'){
          this.instabiliMiglModerataInterventi = values[i];
        }
        else if (key === 'InstabiliMiglGraveInterventi'){
            this.instabiliMiglGraveInterventi = values[i];
        }
        else if (key === 'StabiliRemissioneInterventi'){
          this.stabiliRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliPegLieveInterventi'){
          this.instabiliPegLieveInterventi = values[i];
        }
        else if (key === 'InstabiliPegModerataInterventi'){
            this.instabiliPegModerataInterventi = values[i];
        }
        else if (key === 'InstabiliPegGraveInterventi'){
            this.instabiliPegGraveInterventi = values[i];
        }
        else if (key === 'InstabiliPegRemissioneInterventi'){
          this.instabiliPegRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneInterventi'){
          this.instabiliMiglRemissioneInterventi = values[i];
        }
        else if (key === 'InstabiliPegRemissioneNoInterventi'){
          this.instabiliPegRemissioneNoInterventi = values[i];
        }
        else if (key === 'InstabiliPegLieveNoInterventi'){
          this.instabiliPegLieveNoInterventi = values[i];
        }
        else if (key === 'InstabiliPegModerataNoInterventi'){
            this.instabiliPegModerataNoInterventi = values[i];
        }
        else if (key === 'InstabiliPegGraveNoInterventi'){
            this.instabiliPegGraveNoInterventi = values[i];
        }
        else if (key === 'StabiliLieveNoInterventi'){
          this.stabiliLieveNoInterventi = values[i];
        }
        else if (key === 'StabiliModerataNoInterventi'){
            this.stabiliModerataNoInterventi = values[i];
        }
        else if (key === 'StabiliGraveNoInterventi'){
            this.stabiliGraveNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneNoInterventi'){
          this.instabiliMiglRemissioneNoInterventi = values[i];
        }
        else if (key === 'StabiliLieveInterventi'){
          this.stabiliLieveInterventi = values[i];
        }
        else if (key === 'StabiliModerataInterventi'){
            this.stabiliModerataInterventi = values[i];
        }
        else if (key === 'StabiliGraveInterventi'){
            this.stabiliGraveInterventi = values[i];
        }
        else if (key === 'InstabiliMiglLieveNoInterventi'){
          this.instabiliMiglLieveNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglModerataNoInterventi'){
            this.instabiliMiglModerataNoInterventi = values[i];
        }
        else if (key === 'InstabiliMiglGraveNoInterventi'){
            this.instabiliMiglGraveNoInterventi = values[i];
        }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGraveNoInterventi);
      this.attivitaGrave.push(this.instabiliMiglGraveNoInterventi);
      this.attivitaGrave.push(this.instabiliPegGraveNoInterventi);
      this.attivitaGrave.push(this.stabiliGraveInterventi);
      this.attivitaGrave.push(this.instabiliMiglGraveInterventi);
      this.attivitaGrave.push(this.instabiliPegGraveInterventi);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieveNoInterventi);
      this.attivitaLieve.push(this.instabiliMiglLieveNoInterventi);
      this.attivitaLieve.push(this.instabiliPegLieveNoInterventi);
      this.attivitaLieve.push(this.stabiliLieveInterventi);
      this.attivitaLieve.push(this.instabiliMiglLieveInterventi);
      this.attivitaLieve.push(this.instabiliPegLieveInterventi);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerataNoInterventi);
      this.attivitaModerata.push(this.instabiliMiglModerataNoInterventi);
      this.attivitaModerata.push(this.instabiliPegModerataNoInterventi);
      this.attivitaModerata.push(this.stabiliModerataInterventi);
      this.attivitaModerata.push(this.instabiliMiglModerataInterventi);
      this.attivitaModerata.push(this.instabiliPegModerataInterventi);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissioneNoInterventi);
      this.remissione.push(this.instabiliMiglRemissioneNoInterventi);
      this.remissione.push(this.instabiliPegRemissioneNoInterventi);
      this.remissione.push(this.stabiliRemissioneInterventi);
      this.remissione.push(this.instabiliMiglRemissioneInterventi);
      this.remissione.push(this.instabiliPegRemissioneInterventi);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableCrohnPreviousSurgery') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableCrohnPreviousSurgery = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableCrohnPreviousSurgery.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableCrohnPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableCrohnPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableCrohnPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableCrohnPreviousSurgery.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}